import styled from 'styled-components';

const FormContainer = styled.div`
  padding-top: 30px;
`;

export default FormContainer;